<template>
  <v-form>
    <v-row>
      <v-col cols="12" md="10">
        <v-row>
          <v-col cols="12" md="4">
            <DateIOSPicker label="Ngày" :date.sync="date" outlined :rules="[$rules.date, $rules.dateFromNow]" dense />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="name"
              clear-icon="mdi-close"
              label="Tên lớp bán trú"
              flat
              outlined
              dense
              clearable
              hide-details
              @keyup.enter="onFilterChanged"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-model="status"
              :items="[
                { title: 'Chưa điểm danh', status: 'created' },
                { title: 'Đã điểm danh', status: 'done' },
              ]"
              clear-icon="mdi-close"
              item-text="title"
              item-value="status"
              label="Chọn trạng thái"
              outlined
              dense
              clearable
              hide-details
            />
          </v-col>
        </v-row>
      </v-col>
      <v-col class="d-flex align-end" cols="12" md="2">
        <v-btn dark outlined class="search-button" @click="onFilterChanged"> Tìm kiếm </v-btn>
        <v-spacer />
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import DateIOSPicker from '@/components/basic/picker/DateIOSPicker.vue'
import moment from 'moment'
export default {
  components: { DateIOSPicker },
  data: () => ({ status: '', name: '', date: moment().toISOString() }),
  methods: {
    onFilterChanged() {
      this.$emit('onFilterChanged', {
        boardingClassTitle_contains: this.name,
        status: this.status,
        date: this.date
      })
    },
  },
}
</script>
